import { LocalStorageUtils } from '../index';


export const RecentAccommodationSearchesLocalStorage = {
    getAccommodationRecentSearches() {
        return LocalStorageUtils.getJSON('accommodation-recent-searches') || [];
    },
    getAccommodationMostRecentSearch() {
        const searches = this.getAccommodationRecentSearches();
        return searches.length > 0 ? searches[0] : null;
    }
};
